module.exports = __webpack_public_path__ + "img/3_b.a333bf67.jpg";